import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from "ag-grid-react";
import {
  ColumnResizedEvent,
  FilterChangedEvent,
  FilterModifiedEvent,
  GridApi,
} from "ag-grid-community";
import "ag-grid-enterprise";
import Customtooltip from "../../../../components/CustomTooltip/index";
import { onGridSizeChanged } from "../../../../components/AgGrid/grid-util";
import { useLocation } from "react-router";
import { constants } from "../../../../common/constants";
import { getRowStyleMuiAgGrid } from "../../../../common/commonFunctions";
import { SLQuoteDashboardSupplyDefs } from "../../../../common/columnSLQuote";

interface AgGridProps {
  title?: string;
  rowData: any;
  height?: any;
  type?: string;
  onClickHan?: any;
  onClickSelectData?: any;
  onCellChange?: any;
  seTtotalSelectedRows?: any;
  getBtnRef?: any;
  getGridApi?: any;
  doesExternalFilterPass?: any;
  isExternalFilterPresent?: any;
  isDeselectAll?: boolean;
  getContextMenuItems?: any;
  globalSearch?: any;
  defaultFilter?: any;
  setSelectedRows?: any;
  // onBtExport?:(event: React.MouseEvent<HTMLButtonElement>) => void;
}

const SLQuoteSupplyGrid = ({
  title,
  rowData,
  height,
  type,
  onClickHan,
  onClickSelectData,
  onCellChange,
  seTtotalSelectedRows,
  getBtnRef,
  getGridApi,
  doesExternalFilterPass,
  isExternalFilterPresent,
  isDeselectAll,
  getContextMenuItems,
  globalSearch,
  defaultFilter,
  setSelectedRows,
}: // onBtExport,
  AgGridProps) => {
  const gridRef = useRef<any>(null);
  const [columnDefs] = useState<any>([...SLQuoteDashboardSupplyDefs]);
  const [selectedData, setSelectedData] = useState<any>([]);
  // const [gridApiParmas, setGridApiParams] = useState<any>(null);

  let gridApi: any;
  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: true,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      tooltipComponent: Customtooltip,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        let isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();
        return false;
      },
      headerClass: function() {
        return 'ag-grid-mui-header-sl-quote';
      }
    };
  }, []);

  useEffect(() => {
    gridApi = gridRef.current!.api;

    getUpdatedData(rowData);
    //getBtnRef(gridRef);
  }, [rowData]);
  const onColumnResized = useCallback((params: ColumnResizedEvent) => { }, []);
 

  const getUpdatedData = useCallback(
    async (data: any) => {
      await gridApi?.applyTransactionAsync(
        { update: [rowData] }
      );
      gridApi?.refreshCells();
    },
    [rowData]
  );

  useEffect(() => {
    if (defaultFilter && gridRef) {
      const filterComponent = gridRef?.current?.api?.getFilterInstance(
        defaultFilter.column
      );
      if (filterComponent) {
        filterComponent?.setModel({ values: defaultFilter.values });
        gridApi.onFilterChanged();
      }
    }
  }, [gridRef]);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
    gridApi = params.api;

    var gridColumnApi = params.columnApi;
    getName(gridApi, gridColumnApi);
    // Emmits the gridApi refrence to the parent component
    if (getGridApi) {
      getGridApi(gridApi, gridColumnApi);
    }
  };

  /**
   * Executes whenever Grid/Table filter modifies - this is more sensitive
   * @param params
   */
  const onFilterModified = (params: FilterModifiedEvent) => {
    const { api, columnApi } = params;
  };

  /**
   * Executes whenever Grid/Table filter changes
   * @param params
   */
  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    api.deselectAll();
    getName(api, columnApi);
  };

  const { pathname } = useLocation();
  /**
   * To skip pinned rows on the basis of Page path
   * @returns shouldSkip : boolean
   */
  const skipPinnedRow = (): boolean => {
    if (pathname && typeof pathname === "string") {
      const pathsToSkip = ["secmaster", "counterParty"];
      for (let aPath of pathsToSkip) {
        if (pathname.endsWith(aPath)) return true;
      }
    }

    //Skip for Contract Activity Popup
    if (type === constants.ContractActivity) return true;

    if (
      type === constants.DtcSummary ||
      type === constants.DtcOut ||
      type === constants.DtcIn
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    const returnInterval = setInterval(() => {
      const gApi = gridRef.current!.api;
      const gColumnApi = gridRef.current!.columnApi;
      getName(gApi, gColumnApi);
    }, 5000, { 'trailing': false, 'leading': false });
    return () => clearInterval(returnInterval);
  }, []);

  const getName = (api: any, columnApi: any) => {
    if (!api || !columnApi || skipPinnedRow()) return;
    let rows: any = {};
    var result = [];
    columnApi?.getAllGridColumns().forEach((item: any) => {
      rows[item.colId] = null;
    });
    let columnsWithAggregation = [
      "lender",
      "value",
      "rate",
      "qty",
    ];
    const columnsWithAvgAggregation = ['rate']

    columnsWithAggregation.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        if (rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));

        }
      });
    });

    columnsWithAvgAggregation.forEach(element => {
      let nodeCount = 0;

      api?.forEachNodeAfterFilter((rowNode: any) => {
        if (rowNode.data[element]) {
          nodeCount++;
        }
      });

      const avg = nodeCount > 0 ? (rows[element] / nodeCount).toString() : '0';

      rows[element] = nodeCount !== 0 ? Number(parseFloat(avg).toFixed(2)) : 0;
    });
    rows["isTotalRow"] = true;
   // rows["receive_type"] = countUnique("receive_type", api);
    rows["lender"] = countUnique("lender", api);
    result.push(rows);
    api?.setPinnedBottomRowData(result);
  };

  /**
   * Method counts the unique value for given attribute (for filtered values also)
   * @param attribute
   * @returns unique values count
   */
  const countUnique = (attribute: string, api: GridApi): number => {
    const uniqueItemsSet: Set<any> = new Set();
    api?.forEachNodeAfterFilter((rowNode: any) => {
      if (rowNode?.data instanceof Object && attribute in rowNode.data) {
        uniqueItemsSet.add(rowNode.data[attribute]);
      }
    });
    return uniqueItemsSet.size;
  };

  useEffect(() => {
    if (isDeselectAll != undefined) gridRef.current?.api?.deselectAll();
  }, [isDeselectAll]);

  const countRows = (rowNode: any, api: GridApi): number => {
    const selectedRows: any = gridRef.current!.api.getSelectedRows();
    if (selectedRows.length === 0) {
      return 0;
    } else {
      return selectedRows.length;
    }
  };

  const countRecall = () => {
    const rowData: any = [];
    gridApi?.forEachNodeAfterFilter((node: any) => rowData.push(node.data));
    const filteredData = rowData?.filter((x: any) => (x?.recall === 'Y' || x?.recall === 'y'))
    return filteredData?.length;
  };

  const rowClassRules = useMemo(() => {
    return {
      "is-new-warning": (params: any) => {
        var isNew = params.data.is_new;
        return isNew === "TRUE";
      },
      "is-new-recall": (params: any) => {
        var isNew = params.data.is_Recall;
        return isNew === "True";
      },
    };
  }, []);

  const onSelectionChanged = useCallback((params: any) => {
    const selectedRows = gridRef.current!.api.getSelectedRows();
    const { api, columnApi } = params;
    getName(api, columnApi);
    setSelectedData(selectedRows);
    setSelectedRows(selectedRows);
    let tempArray: any = [];
    gridApi = gridRef.current!.api;
    gridApi.forEachNodeAfterFilter((node: any) => {
      tempArray.push(node.data);
    });

    let rowDataClear = selectedRows.filter((val: any) => {
      return !tempArray.includes(val);
    });

    let tempClear = tempArray.filter((val: any) => {
      return !selectedRows.includes(val);
    });
    let finalClear = tempArray.filter((val: any) => {
      return !tempClear.includes(val);
    });
    if (
      tempArray.length < rowDataClear.length ||
      (tempArray.length > rowDataClear.length &&
        rowDataClear.length > 0 &&
        tempArray.length > 0)
    ) {
      setSelectedData(finalClear);
      setSelectedRows(finalClear);
    }
    if (seTtotalSelectedRows != undefined) seTtotalSelectedRows?.(selectedRows);
    onClickHan?.(rowDataClear);
    onClickSelectData?.(finalClear);
  }, []);

  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  const onCellValueChanged = useCallback((event: any) => {
    let updateArray: any = [];
    event.value = event.value.toUpperCase();
    onCellChange(event.data, event.value, event.column);
    updateArray.push(event.data);

    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    gridApi?.applyTransaction({ update: updateArray });
    getName(gridApi, gridColumnApi);

    var params = {
      force: true,
      suppressFlash: true,
      columns: [event.column],
    };

    gridApi.refreshCells(params);
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 100,
      maxWidth: 200,
    };
  }, []);

  const getRowId = (params: any) => {
    if (params && params.data) {
      if (params.data.uiTradeId) {
        return params.data.uiTradeId;
      } else if (params.data.id) {
        return params.data.id;
      }
    }
    return makeid(5);
  };

  function makeid(length: any) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  const onGridRowDataChanged = (params: any) => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef.current!.api.refreshCells(refreshParams);
  };

  const onDoesfilter = useCallback((node: any) => {
    doesExternalFilterPass(node);
    return true;
  }, []);

  const isRowSelectable = useMemo(() => {
    return (rowNode: any) => {
      return rowNode?.data?.processing_status !== "Pending";
    };
  }, []);

  const onFirstDataRendered = () => {
    const gApi = gridRef.current!.api;
    const gColumnApi = gridRef.current!.columnApi;
    getName(gApi, gColumnApi);
  }

  return (
    <>
      {title !== undefined && (
        <div
          style={{ height: "4%" }}
          className="drag-handle py-2 title-subHeaderTitle"
        >
          {title}
        </div>
      )}
      <div className="no-border-grid ag-theme-balham w-100" style={{ height: "96%" }}>
        <AgGridReact
          ref={gridRef}
          rowStyle={{
            justifyContent: 'center',
            fontSize: '0.85rem',
            fontWeight: '400',
            fontStyle: 'normal',
            color:'rgba(0, 0, 0, 0.7)',
            fonFamily:"Roboto, Helvetica, Arial, sans-serif"
          }}
          rowHeight={28}
          headerHeight={32}
          columnDefs={columnDefs}
          getRowId={getRowId}
          onRowDataUpdated={onGridRowDataChanged}
          rowData={rowData}
          suppressRowClickSelection={true}
          defaultColDef={defaultColDef}
          suppressAggFuncInHeader={true}
          enableCellChangeFlash={true}
          enableRangeSelection={true}
          onGridReady={onGridReady}
          onFilterModified={onFilterModified}
          onFilterChanged={onFilterChanged}
          onGridSizeChanged={onGridSizeChanged}
          onColumnResized={onColumnResized}
          rowClassRules={rowClassRules}
          onSelectionChanged={onSelectionChanged}
          rowSelection={"multiple"}
          getRowStyle={getRowStyleMuiAgGrid}
          onCellValueChanged={onCellValueChanged}
          autoGroupColumnDef={autoGroupColumnDef}
          groupSelectsChildren={true}
          groupSelectsFiltered={true}
          sideBar={sideBar}
          pivotMode={false}
          cacheQuickFilter={false}
          isExternalFilterPresent={isExternalFilterPresent}
          doesExternalFilterPass={onDoesfilter}
          getContextMenuItems={getContextMenuItems}
          quickFilterText={globalSearch}
          overlayLoadingTemplate={
            '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          }
          isRowSelectable={isRowSelectable}
          onFirstDataRendered={onFirstDataRendered}
        ></AgGridReact>
      </div>
    </>
  );
};

function CustomTooltip() { }

CustomTooltip.prototype.init = function (params: any) {
  var type = params.type || "primary";
  var data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  var eGui = (this.eGui = document.createElement("div"));

  eGui.classList.add("custom-tooltip");
  this.eGui.innerHTML =
    '<div class="panel panel-' +
    type +
    '">' +
    '<div class="panel-heading">' +
    '<h3 class="panel-title">' +
    data.country +
    "</h3>" +
    "</div>" +
    '<div class="panel-body">' +
    '<h4 style="white-space: nowrap;">' +
    data.athlete +
    "</h4>" +
    "<p>Total: " +
    data.total +
    "</p>" +
    "</div>" +
    "</div>";
};

CustomTooltip.prototype.getGui = function () {
  return this.eGui;
};

export default SLQuoteSupplyGrid;
